const Moment = require("moment")

class Project {

    /**
     * Create new Project Instance.
     *
     * @param {object} ref
     */
    constructor (ref) {
        this.id = ref.id
        this.status = ref.status || "открыт"
        this.name = ref.name || "--"
        this.num = ref.num || ''
        this.quantity = ref.quantity || 0
        this.maxQuantity = ref.maxQuantity || 0
        this.sum = ref.sum || 0
        this.maxSum = ref.maxSum || 0
        this.profitExpected = ref.profitExpected || 0
        this.my = false
        this.sumMy = 0
        this.displayName = ref.displayName || ""
        this.active = ref.active || false
        //console.log('date',ref.dateStart.toDate());
        //var date = new DateTime.fromMillisecondsSinceEpoch(timestamp * 1000);
        let d = new Moment(ref.dateStart.toDate()||'')
        this.dateStart = d.format('DD.MM.YY') || ''
        if (ref.dateExpected) { this.dateExpected= new Moment(ref.dateExpected.toDate()).format('DD.MM.YY') }
        else { this.dateExpected='' }
        if (ref.dateFinish) { this.dateFinish= new Moment(ref.dateFinish.toDate()).format('DD.MM.YY') }
        else { this.dateFinish='' }

        this.myInvestments = []

      }

    required () {
        return []
    }
}

export default Project;



// WEBPACK FOOTER //
// ./src/models/Project.js